/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlResolutionRequestAttestation
 */
export interface ControlResolutionRequestAttestation {
    /**
     * 
     * @type {string}
     * @memberof ControlResolutionRequestAttestation
     */
    request_id: string;
    /**
     * 
     * @type {string}
     * @memberof ControlResolutionRequestAttestation
     */
    attestation: string;
    /**
     * 
     * @type {string}
     * @memberof ControlResolutionRequestAttestation
     */
    created: string;
    /**
     * 
     * @type {string}
     * @memberof ControlResolutionRequestAttestation
     */
    updated: string;
}

/**
 * Check if a given object implements the ControlResolutionRequestAttestation interface.
 */
export function instanceOfControlResolutionRequestAttestation(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "request_id" in value;
    isInstance = isInstance && "attestation" in value;
    isInstance = isInstance && "created" in value;
    isInstance = isInstance && "updated" in value;

    return isInstance;
}

export function ControlResolutionRequestAttestationFromJSON(json: any): ControlResolutionRequestAttestation {
    return ControlResolutionRequestAttestationFromJSONTyped(json, false);
}

export function ControlResolutionRequestAttestationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlResolutionRequestAttestation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'request_id': json['request_id'],
        'attestation': json['attestation'],
        'created': json['created'],
        'updated': json['updated'],
    };
}

export function ControlResolutionRequestAttestationToJSON(value?: ControlResolutionRequestAttestation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'request_id': value.request_id,
        'attestation': value.attestation,
        'created': value.created,
        'updated': value.updated,
    };
}

